import Button from '@/common/components/Button';
import Modal from '@/common/components/Modal';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import useUpdateEquipmentLicensePlate from '../../hooks/useUpdateEquipmentLicensePlate';
import { CompanyEquipmentData } from '../../types/companyEquipments.type';
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple';

interface UpdateEquipmentLicensePlateModalProps {
  equipment?: CompanyEquipmentData
}

const UpdateEquipmentLicensePlateModal = ({ equipment }: UpdateEquipmentLicensePlateModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const [messages, setMessages] = useState<string[] | boolean>(false)

  const queryClient = useQueryClient();

  const {
    mutate: updateEquipmentLicensePlate,
    isPending: isUpdateEquipmentLicensePlatePending,
  } = useUpdateEquipmentLicensePlate({
    equipmentId: equipment?.id,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['companyEquipment', equipment?.id] })
      setIsOpen(false)
    },
    onError: (error) => {
      if (error.response?.data.errors.base) {
        setMessages(error.response?.data.errors.base)
      }
    },
  })

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        showClose={false}
        useCancellableFooter
        title="Deseja atualizar a placa para o padrão Mercosul?"
        titleClass="py-2"
        subtitleClassName="mt-1 font-light text-white-300"
        cancelButtonClassName="bg-white-100 rounded-es-lg"
        confirmButtonClassName="bg-blue-700 rounded-ee-lg"
        onConfirm={() => updateEquipmentLicensePlate()}
        disabled={isUpdateEquipmentLicensePlatePending}
        confirmButtonIsLoading={isUpdateEquipmentLicensePlatePending}
        Trigger={(
          <Button operationKlassToCheckPermission="Admin::Client::Equipments::UpdateLicensePlateToMercosulPattern">
            Atualizar
          </Button>
        )}
      />

      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError
        />
      )}
    </>
  )
}

export default UpdateEquipmentLicensePlateModal;
